import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AppConfig } from '../../app.config';
import { UploadService } from '../../services/upload.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {

  @Input() disabled = false;
  @Output() upload: EventEmitter<string> = new EventEmitter();

  @ViewChild('file', { static: false })
  public file: ElementRef;


  constructor(
    private service: UploadService,
    private config: AppConfig
  ) {
  }

  ngOnInit() {
  }

  public chooseFile(file) {
    const f = file.target.files[0] as File;
    if (!(f instanceof File)) {
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(f);
    reader.onload = (event) => {
      const formData = new FormData();
      formData.append('file', f);
      this.service.upload(formData).subscribe(response => this.upload.emit(response));
    }
  }

}

